
import { v4 as uuidv4 } from 'uuid';

// Generate or retrieve a persistent session ID for the current browser session
export const getSessionId = (): string => {
  const storageKey = 'paperverse_session_id';
  
  // Try to get existing session ID from sessionStorage first (persists during browser session)
  let sessionId = sessionStorage.getItem(storageKey);
  
  if (!sessionId) {
    // If not in sessionStorage, check localStorage (persists across browser sessions)
    sessionId = localStorage.getItem(storageKey);
    
    if (!sessionId) {
      // Generate new session ID if none exists
      sessionId = `session_${Date.now()}_${uuidv4()}`;
      localStorage.setItem(storageKey, sessionId);
    }
    
    // Store in sessionStorage for quick access during current session
    sessionStorage.setItem(storageKey, sessionId);
  }
  
  return sessionId;
};

// Clear session (useful for logout)
export const clearSession = (): void => {
  const storageKey = 'paperverse_session_id';
  sessionStorage.removeItem(storageKey);
  localStorage.removeItem(storageKey);
};
